export const PROTOTYPE_STENCIL_SLUG = 'prototype-smt-stencils';
export const FRAMELESS_STENCIL_SLUG = 'frameless-smt-stencils';
export const FRAMED_STENCIL_SLUG = 'framed-smt-stencils';

export const TOP_SIDE = 'top';
export const BOTTOM_SIDE = 'bottom';
export const COMBINED = 'combined';
export const TWO_SIDES = 'both';

export const STENCIL_TOP_SIDE = 'Top Side';
export const STENCIL_BOTTOM_SIDE = 'Bottom Side';
export const STENCIL_COMBINED = 'Combine Top & Bottom';

export const oneItemStencilTypes = [
  TOP_SIDE, BOTTOM_SIDE
]

export const basicStencils = {
  product: null,
  variant: null,
  parameters: {},
  quantity: '1',
};
